import axios from "axios";
import store from '../store';
import { API_BASE_URL, API_ROUTES } from "../config";
import { nbfcLogoutRequest, nbfcLogoutSuccess, logoutRequest, logoutSuccess } from "../store/actions/logOutAction";

const fetchAuctionInvRequest = async ({ reqAuctionId, user_id, accessToken }) => {
	try {
		const res = await axios.get(
			`${API_BASE_URL.BASE_URL}${API_ROUTES.FETCH_AUCTION_PRODUCTS}${reqAuctionId}`,
			{
				headers: {
					"Content-Type": "application/json",
					"User-Id": `${user_id}`,
					"User-Auth": `Bearer ${accessToken}`,
				},
			}
		);
		return res.data;
	} catch (error) {
		if (error?.response?.status === 401) {
			logoutAfterTokenExpireForUser();
		}
		throw error;
	}
};

const fetchAllAuctionListRequest = async ({ user_id, accessToken }) => {
	try {
		const res = await axios.get(
			`${API_BASE_URL.BASE_URL}${API_ROUTES.FETCH_ALL_AUCTION}`,
			{
				headers: {
					"Content-Type": "application/json",
					"User-Id": `${user_id}`,
					"User-Auth": `Bearer ${accessToken}`,
				},
			}
		);
		return res.data;
	} catch (error) {
		if (error?.response?.status === 401) {
			logoutAfterTokenExpireForUser();
		}
		throw error;
	}
};

const submitBidApi = async ({ reqBid }) => {
	try {
		const { data } = await axios({
			method: "post",
			url: `${API_BASE_URL.BASE_URL}${API_ROUTES.SUBMIT_BID_AUCTION}`,
			data: { price: reqBid.price, product_id: reqBid.product_id },
			headers: {
				"Content-Type": "application/json",
				"User-Id": `${reqBid.user_id}`,
				"User-Auth": `Bearer ${reqBid.accessToken}`,
			},
		});
		return data;
	} catch (error) {
		if (error?.response?.status === 401) {
			logoutAfterTokenExpireForUser();
		}
		throw error;
	}
};

const submitOtpRequest = async ({ otpReq }) => {
	try {
		const res = await axios.post(
			`${API_BASE_URL.BASE_URL}${API_ROUTES.SUBMIT_OTP_ROUTE}`,
			{ phone: otpReq },
			{ headers: { "Content-Type": "application/json" } }
		);
		return res.data;
	} catch (error) {
		throw error;
	}
};

const submitLoginRequest = async ({ loginReq }) => {
	try {
		const res = await axios({
			method: "post",
			url: `${API_BASE_URL.BASE_URL}${API_ROUTES.SUBMIT_LOGIN_ROUTE}`,
			headers: { "Content-Type": "application/json" },
			data: { phone: loginReq.phone, otp: loginReq.otp },
		});
		return res.data;
	} catch (error) {
		throw error;
	}
};

const submitNbfcLoginRequest = async ({ loginReq }) => {
	try {
		const res = await axios({
			method: "post",
			url: `${API_BASE_URL.BASE_URL}${API_ROUTES.SUBMIT_NBFC_LOGIN_ROUTE}`,
			headers: { "Content-Type": "application/json" },
			data: { email: loginReq.email, password: loginReq.password },
		});
		return res.data;
	} catch (error) {
		throw error;
	}
};

const createAuctionRequestApi = async ({
	accessToken,
	auction_name,
	start_date,
	end_date,
	file,
	auction_group,
}) => {
	try {
		const res = await axios({
			method: "post",
			url: `${API_BASE_URL.BASE_URL}${API_ROUTES.CREATE_AUCTION_ROUTE}`,
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: `Bearer ${accessToken}`,
			},
			data: {
				name: auction_name,
				start_date: start_date,
				end_date: end_date,
				file: file,
				auction_group: auction_group,
			},
		});
		return res.data;
	} catch (error) {
		if (error?.response.status === 401) {
			logoutAfterTokenExpire();
        }
		throw error;
	}
};

const uploadedAuctionRequestApi = async ({ accessToken, auction_group }) => {
	try {
		const res = await axios({
			method: "get",
			url: `${API_BASE_URL.BASE_URL}${API_ROUTES.FETCH_UPLOADED_AUCTION_ROUTE}${auction_group}`,
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${accessToken}`,
			},
		});
		return res.data;
	} catch (error) {
		if (error?.response.status === 401) {
			logoutAfterTokenExpire();
        }
		throw error;
	}
};

const fetchuploadedAuctionInvRequestApi = async ({
	accessToken,
	auction_id,
}) => {
	try {
		const res = await axios({
			method: "get",
			url: `${API_BASE_URL.BASE_URL}${API_ROUTES.FETCH_UPLOADED_AUCTION_SINGLE_INVENTORY_ROUTE}${auction_id}`,
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${accessToken}`,
			},
		});
		return res.data;
	} catch (error) {
		if (error?.response.status === 401) {
			logoutAfterTokenExpire();
        }
		throw error;
	}
};

const fetchFeatureSettingsApi = async ({ ...props }) => {
	try {
		const res = await axios({
			method: "get",
			url: `${API_BASE_URL.BASE_URL}${API_ROUTES.FETCH_FEATURE_SETTINGS}${props.reqKey}`,
			headers: { "Content-Type": "application/json" },
		});
		return res.data;
	} catch (error) {
		throw error;
	}
};

const fetchBidStatusApi = async ({ accessToken, product_id }) => {
	try {
		const res = await axios({
			method: "get",
			url: `${API_BASE_URL.BASE_URL}${API_ROUTES.FETCH_BID_STATUS_ROUTE}${product_id}`,
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${accessToken}`,
			},
		});
		return res.data;
	} catch (error) {
		if (error?.response.status === 401) {
			logoutAfterTokenExpire();
        }
		throw error;
	}
};

const submitUpdateBidStatusApi = async ({
	accessToken,
	bid_status_id,
	bid_status
}) => {
	try {
		const res = await axios({
			method: "put",
			url: `${API_BASE_URL.BASE_URL}${API_ROUTES.SUBMIT_UPDATE_BID_STATUS_ROUTE}${bid_status_id}`,
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${accessToken}`,
			},
			data: {
				status: bid_status,
			},
		});
		return res.data;
	} catch (error) {
		if (error?.response.status === 401) {
			logoutAfterTokenExpire();
        }
		throw error;
	}
};

const logoutAfterTokenExpire = () => {
	try {
		store.dispatch(nbfcLogoutRequest())
		store.dispatch(nbfcLogoutSuccess())
	} catch (error) {
		throw error;
	}
};

const logoutAfterTokenExpireForUser = () => {
	try {
		store.dispatch(logoutRequest())
		store.dispatch(logoutSuccess())
	} catch (error) {
		throw error;
	}
};


export {
	fetchAuctionInvRequest,
	fetchAllAuctionListRequest,
	submitBidApi,
	submitOtpRequest,
	submitLoginRequest,
	submitNbfcLoginRequest,
	createAuctionRequestApi,
	uploadedAuctionRequestApi,
	fetchuploadedAuctionInvRequestApi,
	fetchFeatureSettingsApi,
	fetchBidStatusApi,
	submitUpdateBidStatusApi,
};
